import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as Hide } from '../assets/icons/hide.svg'
import { ReactComponent as CheckMarkFilled } from '../assets/icons/checkmark-filled.svg'
import { ReactComponent as Warning } from '../assets/icons/warning.svg'
import { useState } from 'react'
import ProgressBar from './ProgressBar'
import { fileTypeList } from '../assets/data'

export default function FileProgressModal({ close, fileInfo, setFileInfo }) {
  const [isListOpen, setIsListOpen] = useState(true)

  const inProgressLength = fileInfo.filter((item) => item.progress < 100).length
  const completedUploadLength = fileInfo.filter((item) => item.status === 'success').length
  const failedUploadLength = fileInfo.filter((item) => item.status === 'error').length
  console.log(inProgressLength)
  return (
    <div className='fixed bottom-0 right-20 z-[200] w-[370px] rounded-t-8 shadow-emphasize'>
      {/* header */}
      <div className='flex w-full items-center justify-between bg-border-alternative fill-label-sub pb-12 pl-16 pr-8 pt-16'>
        <p className='text-body1-medium text-label-default'>
          {fileInfo.length === completedUploadLength + failedUploadLength
            ? failedUploadLength === 0
              ? `자료 ${completedUploadLength}개 업로드 완료`
              : `자료 ${completedUploadLength}개 업로드 완료 (${failedUploadLength}개 실패)`
            : failedUploadLength === 0
              ? `자료 ${inProgressLength}개 업로드 중`
              : `자료 ${inProgressLength}개 업로드 중 (${failedUploadLength}개 실패)`}
        </p>
        <div className='flex items-center gap-12'>
          <Hide
            className={`${isListOpen ? '' : 'rotate-180'} cursor-pointer`}
            onClick={() => setIsListOpen((prev) => !prev)}
          />
          <Close
            onClick={() => {
              close()
              setFileInfo([])
            }}
            className='h-28 w-28 cursor-pointer'
          />
        </div>
      </div>
      {/* 업로드 리스트 */}
      {isListOpen && (
        <div className='w-full divide-y-[1px] divide-solid divide-border-default bg-background-default'>
          {fileInfo?.map((fileItem, fileIndex) => (
            <div
              key={fileIndex}
              className={`${fileItem.status === 'error' ? 'bg-red-99' : 'bg-background-default'} flex items-center justify-between fill-label-sub p-8`}
            >
              <div className='flex items-center gap-4'>
                <div className='h-32 w-32'>
                  {fileTypeList[fileItem.name.split('.').pop().toUpperCase()]}
                </div>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-body2-medium text-label-default'>{fileItem.name}</p>
                  {fileItem.status === 'error' ? (
                    <p className='text-caption-regular text-status-negative'>파일 업로드 에러</p>
                  ) : (
                    <p className='text-caption-regular text-label-info'>
                      {`${(fileItem.size / (1024 * 1024)).toFixed(3)}MB`}
                    </p>
                  )}
                </div>
              </div>
              {fileItem.status === 'success' ? (
                <CheckMarkFilled className='fill-status-positive' />
              ) : fileItem.status === 'error' ? (
                <Warning className='fill-status-negative' />
              ) : (
                <div className='flex items-center gap-4'>
                  <p className='text-caption-regular text-label-info'>{`${fileItem.progress}%`}</p>
                  <ProgressBar progress={fileItem.progress} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
